import { createAction, props } from '@ngrx/store'
import { ContactHistoryModel, RequestModel } from '@models/index'


export const searchContactHistoryByLocation = createAction(
    '[Contact History Page] Search Contact History By Location',
    props<{ request: RequestModel }>()
)

export const searchContactHistoryByBusiness = createAction(
    '[Contact History Page] Search Contact History By Business',
    props<{ request: RequestModel }>()
)

export const searchContactHistorySuccess = createAction(
    '[Campaigns Page] Search Contact History Success',
    props<{ data: ContactHistoryModel }>()
)

export const restartCampaignContactHistory = createAction(
    '[Campaigns Page] Restart Campaign',
    props<{ request: RequestModel }>()
)

export const restartCampaignContactHistorySuccess = createAction(
    '[Campaigns Page] Restart Campaign',
    props<{ contactHistory: ContactHistoryModel }>()
)

export const contactHistoryError = createAction(
    '[Campaigns Page] Campaign Error',
    props<{ error: string }>()
)

